var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Ui-Date-Picker-Range',{attrs:{"id":"calendar"},on:{"input":function($event){return _vm.getCalendarNews($event)}},model:{value:(_vm.calendar),callback:function ($$v) {_vm.calendar=$$v},expression:"calendar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }